import {
  Array,
  Boolean,
  Dictionary,
  Optional,
  Record,
  Static,
  String,
} from "runtypes";

import { FilledDynamicValueTableColumnTypeLiteral } from "../DynamicValue.js";
import { ExploreFieldId, ExploreFieldTypeLiteral } from "../explore/types.js";
import { HqlAggregationFunctionLiteral } from "../hql/types.js";
import {
  AppSessionId,
  CellId,
  DataSourceTableId,
  DisplayTableColumnId,
  SemanticDatasetName,
  SemanticProjectId,
} from "../idTypeBrands.js";
import { SemanticProjectVersionString } from "../semantic-layer/semanticProjectVersionTypes.js";

import { ColumnPredicate } from "./columnPredicateTypes.js";

export const ColumnFilter = Record({
  column: DisplayTableColumnId,
  columnType: Optional(FilledDynamicValueTableColumnTypeLiteral),
  predicate: ColumnPredicate,
  // these fields below are relevant for filtering in explore cells
  // optional for backwards compatibility
  queryPath: Optional(Array(SemanticDatasetName)),
  // dimensions, measures, and columns
  fieldType: Optional(ExploreFieldTypeLiteral),
  // set if filtering by an aggregated dimension in explore
  aggregation: Optional(HqlAggregationFunctionLiteral),
  // true if filters are active but should not show up in UI (e.g. filters copied over to explore)
  hidden: Optional(Boolean),
  // set if lump filter should order by a specific field
  lumpOrderBy: Optional(ExploreFieldId),
});
export type ColumnFilter = Static<typeof ColumnFilter>;

export const TableFiltersDefinition = Array(ColumnFilter);
export type TableFiltersDefinition = Static<typeof TableFiltersDefinition>;

// graphql scalars
export const FilterPatternMap = Dictionary(String, String);
export type FilterPatternMap = Static<typeof FilterPatternMap>;

export type ColumnProfileSemanticDatasetInput = {
  type: "semantic";
  semanticDatasetName: SemanticDatasetName;
  semanticProjectId: SemanticProjectId;
  semanticProjectVersionString?: SemanticProjectVersionString | null;
};

export type ColumnProfileWarehouseTableInput = {
  type: "table";
  dataSourceTableId: DataSourceTableId;
};

export type ColumnProfileDataframeInput = {
  type: "dataframe";
  cellId: CellId;
  appSessionId: AppSessionId;
  dataframeName: string;
};

export type ColumnProfileInput =
  | ColumnProfileSemanticDatasetInput
  | ColumnProfileWarehouseTableInput
  | ColumnProfileDataframeInput;
